import { render, staticRenderFns } from "./CreateStudySetOverview.vue?vue&type=template&id=04a39878&scoped=true&"
import script from "./CreateStudySetOverview.vue?vue&type=script&lang=js&"
export * from "./CreateStudySetOverview.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudySetOverview.vue?vue&type=style&index=0&id=04a39878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a39878",
  null
  
)

export default component.exports